import { MissingDataError, RedirectError } from './errors';

export function assertGuardError(e: unknown): e is RedirectError {
  return e instanceof RedirectError;
}

export function assertMissingDataError(e: unknown): e is MissingDataError {
  return e instanceof MissingDataError;
}
